export default {
  name: "Index",
  data: function data() {
    return {};
  },
  props: ["currentPage", "limits", "totalNumber"]
};